// ─── reactMealPhoto.js ───────────────────────────────────────────────
// 2026-07-21 — Anissa réagit à une photo de repas (❤️ 👍 💪 🔥 👏), façon
// cockpit Benfitcoach. Une seule réaction par photo ; reaction=null efface.
// Passe par le proxy server-side /api/client-app-proxy (Bearer côté serveur).

import { clientAppFetch, ClientAppConfigError, ClientAppHttpError } from "./clientAppFetch";

export class MealReactionError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "MealReactionError";
    this.status = status;
  }
}

function wrapErr(err) {
  if (err instanceof ClientAppConfigError) return new MealReactionError(err.message, 0);
  if (err instanceof ClientAppHttpError) return new MealReactionError(err.message, err.status);
  return err;
}

/**
 * @param {object} params
 * @param {string} params.photoId - id de la photo (client_meal_photos.id)
 * @param {string|null} params.reaction - emoji ou null pour effacer
 * @returns {Promise<object>} { id, reaction, reacted_at }
 */
export async function reactMealPhoto({ photoId, reaction }) {
  if (!photoId) throw new MealReactionError("Photo sans id", 0);
  let resp;
  try {
    resp = await clientAppFetch("/api/admin/meal-photo-reaction", {
      method: "POST",
      payload: { photo_id: photoId, reaction: reaction || null },
    });
  } catch (e) {
    throw wrapErr(e);
  }
  if (!resp?.ok) throw new MealReactionError(resp?.error || resp?.message || "Reponse invalide", 0);
  return resp.photo;
}
